import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* fetchinvoiceConfig(value) {
  console.log(value);
  const token = localStorage.getItem("token");

  let page = (value.value && value.value.page) || 1;
  let user = JSON.parse(localStorage.getItem("user"));
  let id = user.orgId;

  try {
    const res = yield fetch(
      `${appConfig.ip}/invoiceConfig?orgId=${id}&limit=10&page=${page}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_INVOICECONFIG_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: actionTypes.FETCH_INVOICECONFIG_FAIL, error: err });
    } else {
    }
  }
}

function* addInvoiceConfig(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  console.log(user);
  console.log(value);

  const data = {
    terms: value.value.remark,
    user: user.id,
    orgId: user.orgId,
    invoiceStartNo: "dummyINV1",
  };

  let imageData = {
    file: value.value && value.value.image,
  };

  try {
    const res = yield fetch(`${appConfig.ip}/invoiceConfig`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    console.log(res);

    if (!res.ok) {
      throw res;
    } else {
      console.log(resJSON);
      const resJSON = yield res.json();
      if (value.value.image !== "") {
        try {
          const data = new FormData();
          data.append(resJSON.id, imageData.file, imageData.file.name);

          const res1 = yield fetch(`${appConfig.ip}/invoiceConfig/image`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: data,
          });

          if (!res1.ok) {
            throw res1;
          } else {
            let resJSON1 = yield res1.json();
            yield put({
              type: actionTypes.ADD_INVOICECONFIGIMAGE_SUCCESS,
              payload: resJSON1,
            });
            yield put({
              type: actionTypes.ADD_INVOICECONFIG_SUCCESS,
              payload: resJSON,
            });

            yield toast.success("Invoice configuration added successfully", {
              autoClose: 3000,
              className: "toastClass",
            });

            yield put({
              type: actionTypes.FETCH_INVOICECONFIG_INIT,
            });
          }
        } catch (err) {
          if (err.ok === false) {
            yield put({
              type: actionTypes.ADD_INVOICECONFIGIMAGE_FAIL,
              error: err,
            });
          } else {
          }
        }
      } else {
        yield put({
          type: actionTypes.ADD_INVOICECONFIG_SUCCESS,
          payload: resJSON,
        });
        yield toast.success("Invoice configuration added successfully", {
          autoClose: 3000,
          className: "toastClass",
        });

        yield put({
          type: actionTypes.FETCH_INVOICECONFIG_INIT,
        });
      }
    }
  } catch (err) {
    console.log(err);
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_INVOICECONFIG_FAIL,
        error: err,
      });
    }
  }
}

function* addInvoiceConfigImg(value) {
  console.log(value);

  try {
    const data = new FormData();

    data.append(value.id, value.value.file, value.value.file.name);

    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/invoiceConfig/image`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      console.log("*****resJSON******", resJSON);
      yield put({
        type: actionTypes.ADD_INVOICECONFIGIMAGE_SUCCESS,
        payload: resJSON,
      });
      yield put({
        type: actionTypes.FETCH_INVOICECONFIG_INIT,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_INVOICECONFIGIMAGE_FAIL,
        error: err,
      });
    } else {
    }
  }
}

function* editInvoiceConfig(value) {
  console.log(value);
  let id = value.id;

  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  // let data = value.params;
  const data = {
    terms: value.params.remark,
    user: user.id,
    orgId: user.orgId,
    invoiceStartNo: "dummyINV1",
  };

  let imageData = {
    file: value.params && value.params.image,
  };

  try {
    const res = yield fetch(`${appConfig.ip}/invoiceConfig/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      if (value.params.image !== "") {
        try {
          const data = new FormData();
          data.append(resJSON.id, imageData.file, imageData.file.name);

          const res1 = yield fetch(`${appConfig.ip}/invoiceConfig/image`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: data,
          });

          if (!res1.ok) {
            throw res1;
          } else {
            let resJSON1 = yield res1.json();
            yield put({
              type: actionTypes.ADD_INVOICECONFIGIMAGE_SUCCESS,
              payload: resJSON1,
            });
            yield put({
              type: actionTypes.EDIT_INVOICECONFIG_SUCCESS,
              payload: resJSON,
            });

            yield toast.success("Invoice configuration updated successfully", {
              autoClose: 3000,
              className: "toastClass",
            });

            yield put({
              type: actionTypes.FETCH_INVOICECONFIG_INIT,
            });
          }
        } catch (err) {
          if (err.ok === false) {
            yield put({
              type: actionTypes.ADD_INVOICECONFIGIMAGE_FAIL,
              error: err,
            });
          } else {
          }
        }
      } else {
        yield put({ type: actionTypes.FETCH_INVOICECONFIG_INIT });
        yield put({
          type: actionTypes.EDIT_INVOICECONFIG_SUCCESS,
          payload: resJSON,
        });
        yield put({
          type: actionTypes.ADD_INVOICECONFIGIMAGE_INIT,
          value: imageData,
          id: resJSON.id,
        });
        yield toast.success("Invoice configuration updated successfully", {
          autoClose: 3000,
          className: "toastClass",
        });
      }
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.EDIT_INVOICECONFIG_FAIL,
        error: err,
      });
    } else {
    }
  }
}

function* deleteInvoiceConfig(params) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));

  let id = params.data.id;
  let data = {
    status: "deleted",
  };

  try {
    const res = yield fetch(`${appConfig.ip}/invoiceConfig/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ isActive: false, ...data }),
    });
    if (!res.ok) {
      throw res;
    } else {
      yield put({ type: actionTypes.FETCH_INVOICECONFIG_INIT });
      yield put({
        type: actionTypes.DELETE_INVOICECONFIG_SUCCESS,
        payload: id,
      });
      yield toast.success("Invoice configuration deleted successfully", {
        autoClose: 3000,
        className: "toastClass",
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.DELETE_INVOICECONFIG_FAIL,
        error: err,
      });
    } else {
    }
  }
}

export function* InvoiceConfigActionWatcher() {
  yield takeEvery(actionTypes.FETCH_INVOICECONFIG_INIT, fetchinvoiceConfig);
  yield takeEvery(actionTypes.ADD_INVOICECONFIGIMAGE_INIT, addInvoiceConfigImg);
  yield takeEvery(actionTypes.ADD_INVOICECONFIG_INIT, addInvoiceConfig);
  yield takeEvery(actionTypes.EDIT_INVOICECONFIG_INIT, editInvoiceConfig);
  yield takeEvery(actionTypes.DELETE_INVOICECONFIG_INIT, deleteInvoiceConfig);
}
